import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel, Button, Table, Alert, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { renderPanelHeader, formatTime } from './common';
import ui from '../../../common/services/ui';
import { ConfirmationButton } from '../../../common/components/formControls';
import {
	lockWeeklyProgram, unlockWeeklyProgram, closeWeeklyProgram, openWeeklyProgram,
	WEEKLY_PROGRAMS_UNPAGED_REQUEST, WEEKLY_PROGRAMS_UNPAGED_SUCCESS, WEEKLY_PROGRAMS_UNPAGED_FAILURE
} from '../actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock, faClose, faCheck, faUserPlus } from '@fortawesome/free-solid-svg-icons';

class EditWeeklyProgram extends Component {

	constructor(props) {
		super(props);
	}

	filterByWeekday(weeklyPrograms, day) {
		const filteredPrograms = {};
		for (let key in weeklyPrograms) {
			if (weeklyPrograms[key].weekday == day) {
				filteredPrograms[key] = weeklyPrograms[key];
			}
		}
		return filteredPrograms;
	}

	compareTimes(a, b) {
		if (a[1].startTime < b[1].startTime) {
			return -1;
		}
		if (a[1].startTime > b[1].startTime) {
			return 1;
		}
		return 0;
	}

	renderButtonsRow(t) {
		const { weekdays, onNew, isReadonly } = this.props;
		return (
			isReadonly || < tr >
				{weekdays.map(day =>
					<td key={day} className='center'>
						<Button bsStyle='primary' onClick={() => onNew(day)}>{t('Common_New')}</Button>
					</td>)
				}
			</tr>
		);
	}

	renderChildCount(weeklyProgramItem) {
		const { onRenderChildCount, enableTrials, enableMakeUps, t } = this.props;
		if (onRenderChildCount) {
			return onRenderChildCount(weeklyProgramItem);
		} else {
			const { maxChildrenRest, maxTrialChildrenRest, maxMakeUpChildrenRest } = weeklyProgramItem;
			const normalCapacityTxt = t('WeeklyProgram_NormalChild', { count: maxChildrenRest || 0 });
			const normalCapacity = `( ${maxChildrenRest || 0} ${normalCapacityTxt} )`;
			const trialCapacityTxt = t('WeeklyProgram_TrialChild', { count: maxTrialChildrenRest || 0 });
			const trialCapacity = `( ${maxTrialChildrenRest || 0} ${trialCapacityTxt} )`;
			const makeUpCapacityTxt = t('WeeklyProgram_MakeUpChild', { count: maxMakeUpChildrenRest || 0 });
			const makeUpCapacity = `( ${maxMakeUpChildrenRest || 0} ${makeUpCapacityTxt} )`;
			return <React.Fragment>
				{normalCapacity}
				{enableTrials && < br />}
				{enableTrials && trialCapacity}
				{enableMakeUps && < br />}
				{enableMakeUps && makeUpCapacity}
			</React.Fragment>;
		}
	}

	renderProgramEntry(programEntry, day) {
		const { onEdit, showAvailabilityColor, timetableViewType, t } = this.props;
		const entry = programEntry[1];
		const timeframe = `${formatTime(entry.startTime)} - ${formatTime(entry.endTime)}`;
		const childCount = this.renderChildCount(entry);

		let availabilityStyle = 'info';
		if (showAvailabilityColor) {
			const { maxChildrenRest, attendingChildrenCount, attendingTrialReservation } = entry;
			const normalAndReservations = attendingChildrenCount + attendingTrialReservation
			availabilityStyle = maxChildrenRest === 0 || normalAndReservations >= maxChildrenRest ? 'danger' :
				normalAndReservations >= maxChildrenRest / 2 ? 'warning' : 'info';
		}

		return (
			<Alert key={entry.id} bsStyle={availabilityStyle} style={{ position: 'relative' }}>
				<div style={{ position: 'absolute', top: '0', right: '3px' }}>
					{entry.isRemote && <Badge bsStyle='success'>{t('WeeklyProgramItem_RemoteLabel')}</Badge>}
					{entry.lockForPreviousTermCustomersOnly && <Badge style={{ marginLeft: '3px' }} bsStyle='warning'>{t('WeeklyProgramItem_Locked')}</Badge>}
					{entry.isClosed && <Badge style={{ marginLeft: '3px' }} bsStyle='danger'>{t('WeeklyProgramItem_Closed')}</Badge>}
					{entry.hidden && (timetableViewType === 'List' || timetableViewType === 2) && <Badge style={{ marginLeft: '3px' }} bsStyle='info'>{t('WeeklyProgram_Hidden')}</Badge>}
				</div>
				<div>
					<a className='demo btn edit_hour block-element' onClick={() => onEdit(day, entry)} key={entry.id}>
						<strong>{timeframe}</strong>
						<br />
						{entry.name || entry.grade.name}
						<br />
						{childCount}
					</a>
				</div>
			</Alert>
		);
	}

	renderDayProgram(weeklyProgram, day) {
		const dayProgram = this.filterByWeekday(weeklyProgram, day);
		const sortedDayProgram = Object.entries(dayProgram).sort(this.compareTimes);
		return (
			<td key={day} className='center'>
				{sortedDayProgram.map(programEntry => this.renderProgramEntry(programEntry, day))}
			</td>
		);
	}

	renderWeeklyProgram(weeklyProgram, columnsLength, t) {
		if (Object.keys(weeklyProgram).length === 0) {
			return (
				<tr>
					<td className='center' colSpan={columnsLength}>{t('WeeklyProgram_Empty')}</td>
				</tr>
			);
		}

		return (
			<tr>
				{this.props.weekdays.map(day => this.renderDayProgram(weeklyProgram, day))}
			</tr>
		);
	}

	handleLockAll() {
		const { center, term, lockWeeklyProgram } = this.props;
		if (term && center) {
			lockWeeklyProgram(term.id, center.id, 1);
		}
	}

	handleUnlockAll() {
		const { center, term, unlockWeeklyProgram } = this.props;
		if (term && center) {
			unlockWeeklyProgram(term.id, center.id, 1);
		}
	}

	handleCloseAll() {
		const { center, term, closeWeeklyProgram } = this.props;
		if (term && center) {
			closeWeeklyProgram(term.id, center.id, 1);
		}
	}

	handleOpenAll() {
		const { center, term, openWeeklyProgram } = this.props;
		if (term && center) {
			openWeeklyProgram(term.id, center.id, 1);
		}
	}
	render() {
		const { weeklyPrograms, t, center, term, onNew, hideButtons, headerResource, weekdays, isReadonly, enableAutoEnrolment } = this.props;

		const header = renderPanelHeader(t(headerResource ? headerResource : 'WeeklyProgram_WeeklyProgram'), center, term);
		return (
			<Panel>
				<Panel.Heading>{header}</Panel.Heading>
				<Panel.Body>
					<ReduxBlockUi block={WEEKLY_PROGRAMS_UNPAGED_REQUEST} unblock={[WEEKLY_PROGRAMS_UNPAGED_SUCCESS, WEEKLY_PROGRAMS_UNPAGED_FAILURE]}>
						{hideButtons || <Link to='/weeklyProgram' className='btn btn-default mb-1'>{t('Common_BackToList')}</Link>}
						{!hideButtons && enableAutoEnrolment && center && term && (
							<Link
								to={`/weeklyProgram/action?type=autoEnrol&centerId=${center.id}&termId=${term.id}`}
								className='btn btn-primary ml-0 mb-1'>
								<FontAwesomeIcon icon={faUserPlus} /> {t('WeeklyProgram_AutoEnrol')}
							</Link>
						)}
						{hideButtons || isReadonly || <ConfirmationButton
							onConfirmation={() => this.handleLockAll()}
							confirmationTitle={t('WeeklyProgram_LockAllConfirmationTitle')}
							confirmationMessage={t('WeeklyProgram_LockAllConfirmationMessage')}
							displayType={'inline'}
							label={t('WeeklyProgram_LockAll')}
							btnClasses='ml-0 mb-1'
							bsStyle='primary'
							icon={faLock}
						/>}
						{hideButtons || isReadonly || <ConfirmationButton
							onConfirmation={() => this.handleUnlockAll()}
							confirmationTitle={t('WeeklyProgram_UnlockAllConfirmationTitle')}
							confirmationMessage={t('WeeklyProgram_UnlockAllConfirmationMessage')}
							displayType={'inline'}
							label={t('WeeklyProgram_UnlockAll')}
							btnClasses='ml-0 mb-1'
							bsStyle='primary'
							icon={faUnlock}
						/>}
						{hideButtons || isReadonly || <ConfirmationButton
							onConfirmation={() => this.handleCloseAll()}
							confirmationTitle={t('WeeklyProgram_CloseAllConfirmationTitle')}
							confirmationMessage={t('WeeklyProgram_CloseAllConfirmationMessage')}
							displayType={'inline'}
							label={t('WeeklyProgram_CloseAll')}
							btnClasses='ml-0 mb-1'
							bsStyle='primary'
							icon={faClose}
						/>}
						{hideButtons || isReadonly || <ConfirmationButton
							onConfirmation={() => this.handleOpenAll()}
							confirmationTitle={t('WeeklyProgram_OpenAllConfirmationTitle')}
							confirmationMessage={t('WeeklyProgram_OpenAllConfirmationMessage')}
							displayType={'inline'}
							label={t('WeeklyProgram_OpenAll')}
							btnClasses='ml-0 mb-1'
							bsStyle='primary'
							icon={faCheck}
						/>}
						<Table responsive bordered striped hover>
							<thead>
								<tr>{weekdays.map(day => <th key={day} className='center'>{t(ui.days[day])}</th>)}</tr>
							</thead>
							<tbody>
								{onNew && this.renderButtonsRow(t)}
								{this.renderWeeklyProgram(weeklyPrograms, weekdays.length, t)}
							</tbody>
						</Table>
					</ReduxBlockUi>
				</Panel.Body>
			</Panel>
		);
	}
}

export default connect(state => ({
	weekdays: Object.keys(ui.days).filter(key => Number(key) > 0)
}), {
	lockWeeklyProgram,
	unlockWeeklyProgram,
	closeWeeklyProgram,
	openWeeklyProgram
})(EditWeeklyProgram);